@use 'vars';
@use 'mixins';

.iq-result-body {
  display: flex;
  flex-direction: column;
  gap: vars.$gap-xsmall;

  &__description-container {
    @include mixins.scrollable-container;
    max-height: 250px;
  }

  &__description {
    color: vars.$ai-primary;
  }

  &__description--thinking {
    animation: opacity-text-animation 1s ease-in-out infinite;
  }

  &__description--error {
    color: vars.$dark-blue;
  }
}

@keyframes opacity-text-animation {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
